/**
 * Seller intake launch configuration (M19).
 */

const DISABLED_VALUES = new Set(["false", "0", "off", "no"]);

/**
 * Public seller intake UI (form + footer links).
 * Defaults to enabled when unset.
 *
 * Set REACT_APP_SELLER_INTAKE_ENABLED=false to hide the form and footer links.
 *
 * @returns {boolean}
 */
export function isSellerIntakeEnabled() {
  const raw = String(process.env.REACT_APP_SELLER_INTAKE_ENABLED ?? "true")
    .trim()
    .toLowerCase();
  return !DISABLED_VALUES.has(raw);
}

export const SELLER_INTAKE_DISABLED_MESSAGE_ES =
  "El envío de vehículos no está disponible temporalmente. Intenta más tarde.";
